import { useAuthStore } from "@/stores/auth";
import isMiddleware from "@/router/middleware/isMiddleware";

const needle = "guest";

export default function (to, from, next) {
  const rule = to.meta["middleware"];
  if (!rule || !isMiddleware(needle, rule)) return false;

  const authStore = useAuthStore();
  const hasUser = !!authStore.userData;

  return hasUser ? next({ name: "home" }) : false;
}
